// src/views/Legal/Support.js
// Página pública de soporte (/contact, /soporte, /support): la que se da a
// Dejavoo/DVStore y a los clientes de Meso 360.
import React from "react";
import company from "../../config/company";

const Support = () => {
  const channels = [
    { label: "Correo", value: company.email, href: `mailto:${company.email}` },
    { label: "Teléfono", value: company.phone, href: company.phoneHref },
    { label: "WhatsApp", value: company.whatsapp, href: company.whatsappHref },
  ];

  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">Soporte</h1>

      <p className="mb-6">
        Soporte de {company.legalName} para {company.products.meso360} y
        nuestras soluciones para restaurantes y comercios.
      </p>

      <div className="grid gap-4 sm:grid-cols-3 mb-6">
        {channels.map((channel) => (
          <a
            key={channel.label}
            href={channel.href}
            target={channel.href.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            className="block rounded-xl border border-gray-200 p-4 hover:border-orange-300 hover:bg-orange-50 transition"
          >
            <span className="block text-sm text-gray-500">{channel.label}</span>
            <span className="block font-semibold text-gray-900 break-all">{channel.value}</span>
          </a>
        ))}
      </div>

      {company.supportHours && (
        <p className="mb-2">
          <strong>Horario:</strong> {company.supportHours}
        </p>
      )}
      {company.emergencyNote && (
        <p className="mb-6">
          <strong>{company.emergencyNote}</strong>{" "}
          Si tu operación está detenida (no puedes cobrar o tomar órdenes),
          escríbenos al{" "}
          <a className="text-orange-700 underline" href={company.whatsappHref} target="_blank" rel="noopener noreferrer">
            {company.whatsapp}
          </a>{" "}
          a cualquier hora.
        </p>
      )}

      <h2 className="text-xl font-semibold mt-6 mb-2">Para ayudarte más rápido</h2>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Nombre del restaurante o comercio.</li>
        <li>
          El equipo donde pasa (teléfono, tableta o terminal P8) y la versión
          de {company.products.meso360} (en Mi cuenta).
        </li>
        <li>Qué estabas haciendo, qué esperabas y qué pasó. Una foto de la pantalla ayuda.</li>
        <li>Si es un cobro: la hora y el monto aproximados, o la referencia de la venta.</li>
      </ul>

      <div className="rounded-xl border border-orange-200 bg-orange-50 p-4 mb-4">
        <p className="font-semibold text-orange-800">
          Nunca te pediremos números de tarjeta, códigos de seguridad,
          contraseñas, PIN ni códigos de acceso.
        </p>
        <p className="text-sm text-orange-900 mt-1">
          Si alguien los pide en nombre de BBTS, no los compartas y escríbenos.
        </p>
      </div>

      <h2 className="text-xl font-semibold mt-6 mb-2">Pagos con tarjeta</h2>
      <p className="mb-4">
        Las aprobaciones, reembolsos, contracargos y depósitos los maneja el
        procesador del comercio (Clover/Fiserv o Dejavoo/iPOSpays). Te
        ayudamos a encontrar la venta en {company.products.meso360} y a
        contactar al procesador cuando haga falta.
      </p>

      <p className="text-sm text-gray-500 mt-8">
        <a className="underline" href="/privacidad">Privacidad</a>
        {" · "}
        <a className="underline" href="/terminos">Términos</a>
        {" · "}
        <a className="underline" href="/disclaimers">Avisos legales</a>
      </p>
    </div>
  );
};

export default Support;
